const __WEBPACK_NAMESPACE_OBJECT__ = require("@rajesh896/broprint.js");